// extracted by mini-css-extract-plugin
export default {"page":"voS86","emptyAd":"HpFZq"};